import { createUseStyles } from 'react-jss';

// This styling exists to mimic the size_xs_50_sm_33 class. To adjust the
// number of columns for xs and sm just replace the values below.
// This is necessary as this car_badge_button_group has custom logic that
// cannot be replicated using the existing radio button group.
// Sizes defined in badge.css:
const flexBasisThird = '32%';
const flexBasisHalf = '48.5%';
const flexBasisQuarter = '24%';

export const useStyles = createUseStyles((theme) => ({
    badge_button_group: ({ isFourColumn }) => ({
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
        justifyContent: 'center',
        '& a:nth-child(3n)': {
            marginRight: isFourColumn ? '1%' : 0
        }
    }),
    badge_button_link: ({ isFourColumn, isXS }) => ({
        borderColor: 'transparent',
        display: 'flex',
        width: '100%',
        flexBasis: isFourColumn && !isXS ? flexBasisQuarter : isXS ? flexBasisHalf : flexBasisThird,
        flexDirection: 'column',
        marginRight: '1%',
        '& > div': {
            flexGrow: 1
        }
    }),
    '@media (max-device-width: 767px)': {
        badge_button_link: {
            width: '100%',
            flexBasis: flexBasisHalf
        },
        badge_button_group: {
            '& a:nth-child(3n)': {
                marginRight: '1%'
            },
            '& a:nth-child(2n)': {
                marginRight: 0
            }
        }
    }
}));
